@if (recentlySearched?.length > 0) {
  <div class="recently-searched">
    <label class=" text-capitalize caption-class" >{{'RECENTLYSEARCHED.recentSearch' | translate}} {{header}}</label>
    <ul class="text-list">
      @for (item of recentlySearched  ; track item) {
        <li class="search-item" (click)="addData(item)">
          <span>{{item.hasOwnProperty('ItemName')? item.ItemName:item.Name}}</span>
          <!-- <i class="icon-add add-btn"></i> -->
        </li>
      }
    </ul>
  </div>
}
